function doesArrayContainProvidedElement(array, element) {
  return array.includes(element);
}
export {
  doesArrayContainProvidedElement
};
//# sourceMappingURL=condition-checkers.es.js.map
